import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { firstValueFrom, startWith } from 'rxjs';
import { DictionaryService } from 'src/app/data/dictionary.service';
import { EDocumentationService } from 'src/app/data/e-documentation-service';
import { EDocumentPermissionDto } from 'src/app/models/dtos/e-document-permission-dto';
import { EDocumentTypeDto } from 'src/app/models/dtos/e-document-type-dto';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-document-permission-settings',
  templateUrl: './document-permission-settings.component.html',
  styleUrl: './document-permission-settings.component.scss',
  standalone: false
})
export class DocumentPermissionSettingsComponent implements OnInit {

  constructor(
    public dictionaryService: DictionaryService,
    public eDocumentationService: EDocumentationService,
    public changeDetectorRef: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private snackbar: SnackBarService
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.documentTypes = await firstValueFrom(this.dictionaryService.getEDocumentTypes());
    await this.fetch();

    this.select.setValue(1);


    this.select.valueChanges.pipe(startWith(this.select.value)).subscribe(value => {
      const rolePermissions = this.rolesPermissions.find(rp => rp.RoleId === value);
      this.allow = this.documentTypes.filter(dt => rolePermissions?.EDocumentTypeIds.includes(dt.Id));
      this.deny = this.documentTypes.filter(dt => !rolePermissions?.EDocumentTypeIds.includes(dt.Id));
      this.changeDetectorRef.detectChanges();
    })
  }

  select = new FormControl();
  documentTypes: EDocumentTypeDto[];
  rolesPermissions: EDocumentPermissionDto[];
  deny: EDocumentTypeDto[] = [];
  allow: EDocumentTypeDto[] = [];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  async fetch() {
    this.rolesPermissions = await firstValueFrom(this.eDocumentationService.getEDocumentPermission());
  }

  async save() {
    try {
      this.spinner.show();

      const res: EDocumentPermissionDto = {
        RoleId: this.select.value,
        EDocumentTypeIds: this.allow.map(a => a.Id)
      };

      const index = this.rolesPermissions.findIndex(rp => rp.RoleId == res.RoleId);

      if (index > -1) {
        this.rolesPermissions[index] = res;
      } else {
        this.rolesPermissions.push(res);
      }

      await firstValueFrom(this.eDocumentationService.saveEDocumentPermission(res));

      this.snackbar.openSuccessSnackBar('Pomyślnie zapisano uprawnienia');

    } finally {
      this.spinner.hide();
    }
  }
}
